type LegalConsentModalProps = {
  labels: {
    title: string;
    body: string;
    privacy: string;
    terms: string;
    disclaimer: string;
    accept: string;
    exit: string;
  };
  onOpenPrivacy: () => void;
  onOpenTerms: () => void;
  onAccept: () => void;
  onExit: () => void;
};

export function LegalConsentModal({ labels, onOpenPrivacy, onOpenTerms, onAccept, onExit }: LegalConsentModalProps) {
  return (
    <div className="sheet-overlay" onClick={() => undefined}>
      <div className="sheet onboarding-sheet legal-consent-sheet" onClick={(e) => e.stopPropagation()}>
        <div className="sheet-header">
          <h3>{labels.title}</h3>
        </div>
        <div className="small legal-consent-body">{labels.body}</div>
        <div className="card legal-consent-links">
          <button className="settings-action" onClick={onOpenPrivacy}>
            {labels.privacy}
          </button>
          <button className="settings-action" onClick={onOpenTerms}>
            {labels.terms}
          </button>
        </div>
        <div className="small legal-consent-disclaimer">{labels.disclaimer}</div>
        <div className="timer-buttons onboarding-actions">
          <button onClick={onExit}>{labels.exit}</button>
          <button onClick={onAccept}>{labels.accept}</button>
        </div>
      </div>
    </div>
  );
}
